import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { ArrowLeft, X } from "lucide-react";

interface NoAssetScreenProps {
  onBack: () => void;
  onClose: () => void;
  onRetry: () => void;
}

export function NoAssetScreen({ onBack, onClose, onRetry }: NoAssetScreenProps) {
  useLingui();
  return (
    <div className="mt-[60px] flex  flex-col gap-10 px-4 py-6 md:gap-20 md:px-8 md:py-10">
      <div className="mx-auto flex w-full max-w-screen-md items-center justify-between">
        <button
          onClick={onBack}
          className="py-2.5 hover:bg-muted flex w-fit items-center gap-2 rounded-full bg-[#1E1E1F] px-10 py-6 text-[16px] text-[#ffff6] ring-1 ring-[#fff56] transition-colors hover:ring-[#FFF] md:text-[20px]"
          aria-label={t`Go back`}
        >
          <ArrowLeft className="" />
          <Trans>Back</Trans>
        </button>
        <button
          onClick={onClose}
          className="py-2.5 hover:bg-muted flex w-fit items-center gap-2 rounded-full bg-[#1E1E1F] px-6 py-6 text-[16px] text-[#ffff6] ring-1 ring-[#fff56] transition-colors hover:ring-[#FFF] md:text-[20px]"
          aria-label={t`Close`}
        >
          <X />
        </button>
      </div>

      <div className="mx-auto mt-48 flex w-full max-w-screen-sm flex-1 flex-col items-center justify-center md:mt-96">
        <h1 className="text-foreground text-balance text-center text-34 font-bold md:text-40"><Trans>No assets found</Trans></h1>
        <p className="text-muted-foreground leading-relaxed mt-4 max-w-screen-sm text-pretty text-center text-[15px] md:text-[18px]">
          <Trans>Your wallet was scanned, but no supported assets were found. Try again or connect a different wallet.</Trans>
        </p>

        <button
          onClick={onRetry}
          className="mt-20 w-[404px] rounded-full bg-[#00EC97] py-4 text-[20px] font-semibold text-black transition-all hover:brightness-110 active:scale-[0.98] md:py-8 md:text-[22px]"
        >
          <Trans>Retry</Trans>
        </button>
      </div>
    </div>
  );
}
